export const cookieSessionName = window.ENV.AMPLITUDE_COOKIE_SESSION_NAME;
export const cookieDeviceName = window.ENV.AMPLITUDE_COOKIE_DEVICE_NAME;
export const amplitudeKey = window.ENV.AMPLITUDE_KEY;
